<template>
<div class="tourial-app" :class="{'tourial-native': isApp, 'poi-panel-open': poiPanelOpen}">
    <Splash :visible="loading && isApp" :innerHeight="innerHeight" />
    <vs-sidebar v-if="!isMobile && !$route.meta.print && !$route.meta.hiddenMenu && !poiPanelOpen" absolute reduce v-model="active" open style="padding-top: 16px; border-top-right-radius: 0;">
        <vs-sidebar-item id="HomePage">
            <template #icon>
                <img class="active" src="./assets/icons/menu/home_active.png" alt="menu-aboutus-active" />
                <img class="inactive" src="./assets/icons/menu/home.png" alt="menu-aboutus" />
            </template>
            {{ $t('common.homePage') }}
        </vs-sidebar-item>
        <vs-sidebar-item id="Esplora">
            <template #icon>
                <img class="active" src="./assets/icons/menu/explore_active.png" alt="menu-explore-active" />
                <img class="inactive" src="./assets/icons/menu/explore.png" alt="menu-explore" />
            </template>
            {{ $t('common.explore') }}
        </vs-sidebar-item>
        <vs-sidebar-item id="Viaggi" :disabled="user == null">
            <template #icon>
                <img class="active" src="./assets/icons/menu/trips_active.png" alt="menu-trips-active" />
                <img class="inactive" src="./assets/icons/menu/trips.png" alt="menu-trips" />
            </template>
            {{ $t('common.trips') }}
        </vs-sidebar-item>
        <vs-sidebar-item id="Preferiti" :disabled="user == null">
            <template #icon>
                <img class="active" src="./assets/icons/menu/favourites_active.png" alt="menu-favourites-active" />
                <img class="inactive" src="./assets/icons/menu/favourites.png" alt="menu-favourites" />
            </template>
            {{ $t('common.favourites') }}
        </vs-sidebar-item>

        <vs-sidebar-item id="Profilo" :disabled="user == null">

            {{ $t('common.profile') }}

            <template #icon>
                <vs-avatar badge-color="danger" badge-position="top-right" size="32" square>
                    <img class="active" src="./assets/icons/menu/profile_active.png" alt="menu-profile-active" />
                    <img class="inactive" src="./assets/icons/menu/profile.png" alt="menu-profile" />

                    <template #badge v-if="notificationsCount > 0">
                        {{ notificationsCount > 10 ? '10+' : notificationsCount }}
                    </template>
                </vs-avatar>
            </template>
        </vs-sidebar-item>

        <vs-sidebar-item id="ContactUs">
            <template #icon>
                <img class="active" src="./assets/icons/menu/contact_active.png" alt="menu-contactus-active" />
                <img class="inactive" src="./assets/icons/menu/contact.png" alt="menu-contactus" />
            </template>
            {{ $t('common.contactUs') }}
        </vs-sidebar-item>

        <vs-sidebar-item id="Blog">
            <template #icon>
                <img class="active" src="./assets/icons/menu/blog_active.png" alt="menu-blog-active" />
                <img class="inactive" src="./assets/icons/menu/blog.png" alt="menu-blog" />
            </template>
            {{ $t('common.blog') }}
        </vs-sidebar-item>

        <vs-sidebar-group v-if="user !== null && user !== false && user.is_admin">
            <template #header>
                <vs-sidebar-item arrow>
                    <template #icon>
                        <img class="active" src="./assets/icons/menu/admin_active.png" />
                        <img class="inactive" src="./assets/icons/menu/admin.png" />
                    </template>
                    Administration
                </vs-sidebar-item>
            </template>

            <vs-sidebar-item id="ADM_POI">
                <template #icon>
                    <img class="active" src="./assets/icons/menu/admin_pois_active.png" />
                    <img class="inactive" src="./assets/icons/menu/admin_pois.png" />
                </template>
                POIs
            </vs-sidebar-item>
            <vs-sidebar-item id="ADM_Cities">
                <template #icon>
                    <i class="bx bxs-buildings bx-sm active"></i>
                    <i class="bx bxs-buildings bx-sm inactive" style="color: #ded9e2"></i>
                </template>
                Cities
            </vs-sidebar-item>

            <vs-sidebar-item id="ADM_Targets">
                <template #icon>
                    <img class="active" src="./assets/icons/menu/admin_target_active.png" />
                    <img class="inactive" src="./assets/icons/menu/admin_target.png" />
                </template>
                Targets
            </vs-sidebar-item>

            <vs-sidebar-item id="ADM_Notifications">
                <template #icon>
                    <img class="active" src="./assets/icons/menu/admin_notifications_active.png" />
                    <img class="inactive" src="./assets/icons/menu/admin_notifications.png" />
                </template>
                Notifications
            </vs-sidebar-item>

            <vs-sidebar-item id="ADM_Partner">
                <template #icon>
                    <img class="active" src="./assets/icons/menu/admin_partner_active.png" />
                    <img class="inactive" src="./assets/icons/menu/admin_partner.png" />
                </template>
                Partner
            </vs-sidebar-item>

            <vs-sidebar-item id="ADM_Link">
                <template #icon>
                    <img class="active" src="./assets/icons/menu/admin_link_active.png" />
                    <img class="inactive" src="./assets/icons/menu/admin_link.png" />
                </template>
                Links
            </vs-sidebar-item>

            <vs-sidebar-item id="ADM_Analytics">
                <template #icon>
                    <img class="active" src="./assets/icons/menu/admin_analytics_active.png" />
                    <img class="inactive" src="./assets/icons/menu/admin_analytics.png" />
                </template>
                Analytics
            </vs-sidebar-item>

            <vs-sidebar-item id="ADM_Coupons">
                <template #icon>
                    <img class="active" src="./assets/icons/menu/admin_coupons_active.png" />
                    <img class="inactive" src="./assets/icons/menu/admin_coupons.png" />
                </template>
                Coupons
            </vs-sidebar-item>

            <vs-sidebar-item id="ADM_GooglePlaces">
                <template #icon>
                    <img class="active" src="./assets/icons/menu/google_active.png" />
                    <img class="inactive" src="./assets/icons/menu/google.png" />
                </template>
                Google Places
            </vs-sidebar-item>

            <vs-sidebar-item id="ADM_Reviews">
                <template #icon>
                    <img class="active" src="./assets/icons/menu/admin_reviews_active.png" />
                    <img class="inactive" src="./assets/icons/menu/admin_reviews.png" />
                </template>
                Recensioni
            </vs-sidebar-item>
        </vs-sidebar-group>

    </vs-sidebar>
    <template v-else>
        <MobileNavbar v-if="!$route.meta.print && !$route.meta.hiddenMenu && !mobileNavbarHidden && !poiPanelOpen" :user="user" :userLoaded="userLoaded" :highContrast="$route.name !== 'Esplora'"/>
        <MobileMenu v-if="mobileMenuVisible" :user="user" :innerHeight="innerHeight" @close="() => {mobileMenuVisible = false}" :userLoaded="userLoaded" />
    </template>

    <BreadCumb v-if="isMobile && showBreadcumb && !mobileMenuVisible" :name="backName" :back="back" />

    <transition name="fade">
        <RouterView style="width: 100%; overflow-y: auto;" :style="{paddingTop: ($route.meta.breadcumb ? (30+30) : 30) + 'px'}" :user="user" :userLoaded="userLoaded" :innerHeight="innerHeight" :firebaseToken="firebaseToken"/>
    </transition>
    <CookieConsent v-if="!$route.meta.print && !$IS_APP && !cookieHidden"/>
    <DialogWrapper v-if="dialogComponent != null" :component="dialogComponent" :callback="dialogCallback" :is-mobile="isMobile" :data="dialogData" :prevent-close="dialogPreventClose" @close="hideDialog" />
    <slideout-panel></slideout-panel>
</div>
</template>

<script>
import {
    Device
} from '@capacitor/device';
import MobileNavbar from './components/MobileNavbar.vue'
import MobileMenu from './components/MobileMenu.vue'
import Splash from './components/Splash.vue'
import BreadCumb from './components/BreadCumb.vue'
import {
    apiCall,
    coreCall,
} from './utils/ApiMiddleware'
import {
    s3Client
} from './utils/S3Client'
import {
    GlobalEventEmitter
} from './utils/GlobalEventEmitter'
import CookieConsent from './components/CookieConsent.vue'
import DialogWrapper from './components/DialogWrapper.vue'
import TrialExpiredDialog from './components/dialogs/TrialExpiredDialog.vue'
import RenewFailedDialog from './components/dialogs/RenewFailedDialog.vue'
import DeactivatedDialog from './components/dialogs/DeactivatedDialog.vue'
import { PushNotifications } from '@capacitor/push-notifications';
import { localeReadiness } from './utils/wpmlLocale.js'

export default {
    name: 'App',
    components: {
        MobileNavbar,
        MobileMenu,
        Splash,
        BreadCumb,
        CookieConsent,
        DialogWrapper
    },

    computed: {
        isApp() {
            return this.$IS_APP;
        },

        enabledFeatures() {
            return this.$FEATURES.settings;
        }
    },

    data() {
        return {
            isMobile:  window.innerWidth < 600,
            active: 'explore',
            activeProxy: null,
            prevRoute: null,
            mobileMenuVisible: false,
            mobileNavbarHidden: false,
            cookieHidden: false,
            poiPanelOpen: false,
            poiPanelsOpenCount: 0,
            history: [],
            loading: true,
            showBreadcumb: false,
            user: null,
            userLoaded: false,
            innerHeight: window.innerHeight,
            backName: '',
            notificationsCount: 0,
            expiringNotificationShown: false,

            checkSubscriptionActivationTimeout: null,
            checkSubscriptionActivationAttempts: 0,

            firebaseToken: null,

            // Generic dialog host — moved up from Explore.vue so dialogs (including the
            // trial-expired one) can be shown on top of ANY route, e.g. Blog.
            dialogComponent: null,
            dialogCallback: null,
            dialogData: null,
            dialogPreventClose: false
        }
    },

    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, {
                passive: true
            })
        }
        // removes event listener
        GlobalEventEmitter.$off('loadUserMeta', this.getUser)
        GlobalEventEmitter.$off('getNotificationsCount', this.getNotificationsCount);
        GlobalEventEmitter.$off('showExpiringNotification', this.showExpiringNotification);
        GlobalEventEmitter.$off('checkSubscriptionActivation', this.checkSubscriptionActivation);
        GlobalEventEmitter.$off('setMobileNavbarVisible', this.setMobileNavbarVisible);
        GlobalEventEmitter.$off('showPaymentRequired', this.showPaymentRequired);
        GlobalEventEmitter.$off('showDialog', this.showDialog);
        GlobalEventEmitter.$off('hideDialog', this.hideDialog);
        GlobalEventEmitter.$off('poiPanelOpen');
        GlobalEventEmitter.$off('poiPanelClose');

    },

    async mounted() {
        if(this.$IS_APP){
            document.body.className += ' app';
        }
        await this.loadFeatures();


        this.onResize()
        window.addEventListener('resize', this.onResize, {
            passive: true
        })
        
        this.getUser().then(() => {
            setTimeout(() => {
                this.loading = false
            }, 500);    
        });

        

    },

    methods: {
        setMobileNavbarVisible(v){
            this.mobileNavbarHidden = !v;
        },

        // Routes that count as "opening the app/webapp" — i.e. a fresh/cold
        // entry point rather than a deliberate deep link. A logged-in user
        // landing on one of these should be routed to their proper landing
        // page (via redirectAfterAuth), while any other (deep-linked) route is
        // left untouched.
        //
        // NOTE: `preauth` routes (login/register/…) are intentionally NOT
        // listed here — those are already handled centrally by canIBeHere().
        //
        // `HomePage` (path '/') is the default entry for both web (HomePage.vue)
        // and the native app (Wizard.vue), so it covers the standard cold open.
        isEntryRoute(){
            const entryRouteNames = ['HomePage'];
            return entryRouteNames.includes(this.$route.name);
        },

        // Centralized post-authentication redirect.
        // Mirrors the logic previously duplicated in Login.vue / Register.vue.
        // Rules:
        //  - mobile + premium            -> Esplora
        //  - mobile + non-premium + APP  -> Blog
        //  - mobile + non-premium + WEB  -> /blog (full navigation)
        //  - desktop                     -> Esplora
        redirectAfterAuth(){
            if(this.isMobile){
                if(this.user && this.user.isPremium){
                    this.$router.push({name: 'Esplora'}); // mobile premium Esplora
                } else {
                    if(this.$IS_APP){
                        this.$router.push({name: 'Blog'}); // mobile app non-premium Blog
                    } else {
                        window.location.href = '/blog'; // mobile web non-prem
                    }
                }
            } else {
                this.$router.push({name: 'Esplora'}); // desktop always Esplora
            }
        },


        // Probe the premium/subscription status by making a silent /pois call.
        async probeHasPremium(){
            const response = await apiCall('GET', '/pois', {limit: 1}, true);
            if (response.status == 402) {
                // 402 Payment Required -> expired
                return false;
            }
            return true;
        },


        showPaymentRequired(){
            if(this.enabledFeatures['trialDialogs'] === false){
                return;
            }

            // Defensive: this can be triggered by any non-silent 402 (e.g. a
            // /pois call from Explore.vue's map, fired independently of
            // getUser()) before `user` meta has actually loaded. Nothing
            // sensible to show yet.
            if(this.user == null){
                return;
            }

            // Avoid showing the dialog on the page we're about to leave.
            // redirectAfterAuth() performs a full `window.location.href`
            // navigation for mobile + non-premium + web users, which
            // destroys and re-mounts the whole app on the destination page
            // (/blog). Any 402 that fires while we're still on the
            // preauth/homepage route (from getUser(), loadTargets(),
            // Explore.vue's POI fetch, etc.) would otherwise flash the
            // dialog here, then show it again once /blog re-mounts. Defer to
            // that fresh mount instead, so it only ever appears once, on the
            // final landing page.
            const isPreauthOrHome = (this.$route.meta && this.$route.meta.preauth === true) || this.$route.name === 'HomePage';
            if(isPreauthOrHome && this.isMobile && !this.$IS_APP && !this.user.isPremium){
                return;
            }

            let c = TrialExpiredDialog;

            // find (if exists) the transaction with status EXPIRED_AFTER_DEACTIVATION and EXPIRED with the most recent date (transaction are already sorted by date, using find we will get the first one)
            const lastTransaction = this.user.transactions.find(x => x.status == 'EXPIRED_AFTER_DEACTIVATION' || x.status == 'EXPIRED');

            if(lastTransaction){
                // determinate which dialog to show
                if(lastTransaction.status == 'EXPIRED_AFTER_DEACTIVATION'){
                    c = DeactivatedDialog;
                } else if(lastTransaction.status == 'EXPIRED'){
                    c = RenewFailedDialog;
                }
            }

            GlobalEventEmitter.$emit('showDialog', c, () => {
                this.$router.push({
                    name: 'Sottoscrizione'
                })
            })
        },

        // Generic dialog host (moved up from Explore.vue). Present at App root so dialogs
        // can be shown on top of any route, including the WordPress-less in-app Blog route.
        showDialog(component, callback, data = null, preventClose = false){
            this.dialogComponent = component;
            this.dialogCallback = callback;
            this.dialogData = data;
            this.dialogPreventClose = preventClose;
        },
        hideDialog(){
            this.dialogComponent = null;
            this.dialogCallback = null;
            this.dialogData = null;
            this.dialogPreventClose = false;
        },


        async initPushNotifications(){
            if(!this.$IS_APP){
                return;
            }

            // Request permission to use push notifications
            // iOS will prompt user and return if they granted permission or not
            // Android will just grant without prompting
            PushNotifications.requestPermissions().then((result) => {
            if (result.receive === 'granted') {
                // Register with Apple / Google to receive push via APNS/FCM
                PushNotifications.register();
            } else {
                // Show some error
                console.log('Push permission not granted');
            }
            });

            // On success, we should be able to receive notifications
            PushNotifications.addListener('registration', async (token) => {
                console.log('Push registration success, token: ' + token.value);
                this.firebaseToken = token.value;

                // Send token to backend
                try {
                    const response = await apiCall('POST', '/users/firebase-token', { token: token.value }, true);
                    if (response.status == 200) {
                        console.log('Firebase token sent to backend successfully');
                    } else {
                       console.log('Error sending firebase token to backend, status code: ' + response.status);
                    }
                } catch (e) {
                    console.log('Error sending firebase token to backend', e);
                }
            });

            // Some issue with our setup and push will not work
            PushNotifications.addListener('registrationError', (error) => {
                console.log('Error on registration: ' + JSON.stringify(error));
            });

            // Show us the notification payload if the app is open on our device
            PushNotifications.addListener('pushNotificationReceived', (notification) => {
                console.log('Push received: ' + JSON.stringify(notification));
            });

            // Method called when tapping on a notification
            PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
                console.log('Push action performed: ' + JSON.stringify(notification));
            });
        },

        async loadFeatures(){
            const info = await Device.getInfo();
            const platform = info.platform;
            const response = await coreCall('GET', window.configuration.BASE_URI + '/configuration/features.json', {t: new Date().getTime()});
            if(response.status == 200){
                this.$FEATURES.settings = response.data[platform] || {};

                // enable premiumSection and inAppPurchases
                this.$FEATURES.settings['premiumSection'] = true;
                this.$FEATURES.settings['inAppPurchases'] = true;
            }
        },

        async checkSubscriptionActivation(settings){ // FOR APP ONLY
            if(this.checkSubscriptionActivationTimeout != null){
                clearTimeout(this.checkSubscriptionActivationTimeout);
                this.checkSubscriptionActivationTimeout = null;
            }

            // call subscriptions/check
            const response = await apiCall('GET', '/subscriptions/check', {
                payment_intent_client_secret: settings.payment_intent_client_secret
            });
            if(response && response.status){

                // go to route called Cancellazione or Attivata


                if(response.status == 201){
                    this.$router.push({ name: 'Attivata' });
                    return;
                } else if(response.status == 304){
                    
                    if(this.checkSubscriptionActivationAttempts < 30){
                        this.checkSubscriptionActivationAttempts++;
                        // retry in 15 seconds
                        this.checkSubscriptionActivationTimeout = setTimeout(() => {
                            this.checkSubscriptionActivation({
                                payment_intent_client_secret: settings.payment_intent_client_secret,
                                showPendingScreenOnFail: false
                            }); // we dont want to show this screen again
                        }, 10000);
                    }

                    if(settings.showPendingScreenOnFail){
                        this.$router.push({ name: 'Attivazione in corso' });
                    }

                    return;
                }
            }
        },

        async getUser() {
            // use apiCall to call the login api
            let response = await apiCall('GET', '/users/info', null, true);

            // if status code is 200, show a success message and redirect to the explore page, otherwise show an error message
            if (response.status == 200) {
                await this.loadTargets();
                const lastTransactions = await this.getLastTransactions();
                if (lastTransactions.length > 0) {
                    // used for other logics, we need this to understand if he has active subscription
                    response.data.subscription = lastTransactions.find(t => t.status == 'ACTIVE');
                } else {
                    response.data.subscription = null;
                }

                response.data.transactions = lastTransactions;
                response.data.isPremium = await this.probeHasPremium();
                this.user = response.data;

                // Apply the server-side profile language immediately, before the
                // locale is announced as final (localeReadiness.ready below) and
                // before any language-dependent content fetch runs. Relying only
                // on the async `user` watcher left a window where the app booted
                // at its provisional/default locale (often Italian), which is why
                // reopening the app showed articles in the wrong language.
                if (response.data.language != null && response.data.language.name != null) {
                    this.$i18n.locale = response.data.language.name.toLowerCase();
                }

                this.getNotificationsCount();
                this.initPushNotifications(); // you must be logged in to initialize push notifications


                if(!response.data.isPremium){
                    this.showPaymentRequired();
                }
            } else {
                this.user = null;
            }

            this.userLoaded = true;

            // Wait a tick so the `user` watcher (which applies the profile
            // language to $i18n.locale) has actually run before announcing the
            // locale as final. Otherwise consumers could see the flag flip
            // before the locale itself settles, and still fetch with the
            // stale/provisional value.
            await this.$nextTick();
            localeReadiness.ready = true;
        },
        async getLastTransactions() {
            const response = await apiCall('GET', '/subscriptions', {
                limit: 20,
                order: 'desc(end_time)',
                only_active: false
            });
            if (response.status == 200) {
                if (response.data.data != null && response.data.data.length > 0) {
                    return response.data.data;
                } else {
                    return [];
                }
            }
            return [];
        },

        async getNotificationsCount() {
            // use apiCall to call the login api
            const response = await apiCall('GET', '/notifications', {
                only_unread: true
            });

            // if status code is 200, show a success message and redirect to the explore page, otherwise show an error message
            if (response.status == 200) {
                if (response.data.data != null) {
                    this.notificationsCount = response.data.data.length;
                    if (response.data.after != null) {
                        this.notificationsCount++; // 11 will be shown as 10+
                    }
                } else {
                    this.notificationsCount = 0;
                }
            }
        },

        onResize() {
            this.isMobile = window.innerWidth < 600
            this.innerHeight = window.innerHeight;
        },
        back() {
            var n = this.$NAVIGATION_HISTORY[this.$NAVIGATION_HISTORY.length - 1];
            if (n == undefined || n.fullPath == '/') {
                this.$router.replace({
                    path: '/explore'
                })
                return;
            }
            this.$router.replace({
                path: n.fullPath
            })
        },

        canIBeHere() {

            if (!this.userLoaded) {
                return true;
            }
            if (this.$route.meta.auth == true && this.user == null) {

                this.$router.push({
                    name: 'Accedi'
                })
                return false;
            } else if (this.$route.meta.preauth == true && this.user != null) {
                this.redirectAfterAuth();
                return false;
            }


            return true;
        },

        async loadTargets(){

            const response = await apiCall('GET', '/targets', {
                limit: 50
            });

            if(response.status == 200){
                let targets = response.data.data;

                let target_icons = [];
                await Promise.all(targets.map(async (target) => {
                    const s3Response = await s3Client.getSignedDownloadURL({
                        name: target.picture,
                    })
                    if (s3Response && s3Response.url) {
                        target_icons[target.id] = s3Response.url;
                    }
                }));

                this.$TARGETS.icons = target_icons;
                this.$TARGETS.data = targets;

                
            }
        },

        async showExpiringNotification() {
            if(!this.userLoaded || this.user == null){
                // retry
                setTimeout(this.showExpiringNotification, 500);
                return;
            }

            if(this.user.is_admin){
                return; // admin
            }

            if(this.user.is_partner){
                return; // partner
            }

            if(this.user.subscription != null){
                return; // abbonato
            }

            if(this.expiringNotificationShown){
                return; // già mostrata per questa istanza di App
            }

            if(this.enabledFeatures['trialCountdown'] === false){
                return; // feature disabilitata
            }

            // se ha una transazione ALMENO UNA in uno di questi stati vuol dire che almeno una volta è stato premium, quindi non mostrare la notifica
            // EXPIRED_AFTER_DEACTIVATION, EXPIRED, DEACTIVATED,RENEWED,ACTIVE
            const statuses = ['EXPIRED_AFTER_DEACTIVATION', 'EXPIRED', 'DEACTIVATED', 'RENEWED', 'ACTIVE'];
            if(this.user.transactions != null && this.user.transactions.length > 0){
                // check if has a transaction with one of the statuses
                if(this.user.transactions.find(t => statuses.includes(t.status)) != null){
                    this.user.hadPremium = true;
                    return;
                }
            }

            // TODO: utente con transazione di rinnovo, non mostrare la notifica, significa che ha già acquistato almeno una volta

            this.expiringNotificationShown = true;


            let days = this.$TRIAL_DAYS - Math.ceil(Math.abs((new Date()) - (new Date(this.user.created_at)))/ (1000 * 60 * 60 * 24));
            if(days < 1){
                days = 0;
            }

            const expiringNotification = this.$vs.notification({
                title: this.$t('explore.expiring.title', {
                    days: days.toString()
                }),
                text: this.$t('explore.expiring.caption'),
                color: 'primary',
                position: 'top-right',
                duration: 10000,
                progress: 'auto',
                classNotification: 'tourial-expiring-notification',
                onClick: () => {
                    expiringNotification.setLoading(true);
                    setTimeout(() => {
                        this.$router.push({name: 'Sottoscrizione'});
                        expiringNotification.close();
                    }, 500);
                }
            })
        }
    },

    created() {
        // adds the event listener function that will handle the event
        GlobalEventEmitter.$on('loadUserMeta', this.getUser)
        GlobalEventEmitter.$on('getNotificationsCount', this.getNotificationsCount);
        GlobalEventEmitter.$on('showExpiringNotification', this.showExpiringNotification);
        GlobalEventEmitter.$on('checkSubscriptionActivation', this.checkSubscriptionActivation);
        GlobalEventEmitter.$on('setMobileNavbarVisible', this.setMobileNavbarVisible);
        GlobalEventEmitter.$on('showPaymentRequired', this.showPaymentRequired);
        GlobalEventEmitter.$on('showDialog', this.showDialog);
        GlobalEventEmitter.$on('hideDialog', this.hideDialog);
        GlobalEventEmitter.$on('poiPanelOpen', () => {
            this.poiPanelsOpenCount = (this.poiPanelsOpenCount || 0) + 1;
            this.cookieHidden = true;
            this.poiPanelOpen = true;
            // ensure any mobile menu drawer is closed while POI panel is open
            this.mobileMenuVisible = false;
        });
        GlobalEventEmitter.$on('poiPanelClose', () => {
            this.poiPanelsOpenCount = Math.max(0, (this.poiPanelsOpenCount || 0) - 1);
            if (this.poiPanelsOpenCount === 0) {
                this.cookieHidden = false;
                this.poiPanelOpen = false;
            }
        });
    },


    watch: {
        '$route'(n) {
            console.log(n.name)


            
            if (!this.canIBeHere()) {
                return;
            }
            this.activeProxy = n.meta.menu;
            this.showBreadcumb = n.meta.breadcumb;

                // Always use i18n for 'Indietro' as backName
                this.backName = this.$t('common.back');
            
        },

        user(n) {
            if (n != null && n != false && n.language != null) {
                this.$i18n.locale = n.language.name.toLowerCase();
            }
            this.canIBeHere();
        },
        userLoaded(n) {
            this.canIBeHere();

            // if i'm on an entry/landing route (e.g. the homepage, i.e. the
            // app/webapp being opened) redirect the logged-in user to the
            // proper landing page (respects premium/app/web rules via
            // redirectAfterAuth). Deep links are left untouched.
            if(n && this.user != null && this.isEntryRoute()){
                this.redirectAfterAuth();
            }

        },
        activeProxy(n) {
            this.active = n;
        },
        active(n) {
            if (n == this.activeProxy) { // already navigated
                return;
            }
            this.$router.push({
                name: n
            })
        }
    }
}
</script>

<style>

:root {
    --primary: #EF7E18;
    --grey-75: #D0C9D6;
    --natural-grey-2: #3F3356;
    --vs-text: 0, 0, 0 !important;
}

body.blured {
    background-image: url(./assets/images/blured-map.png);
}

html {
    height: 100%;
    overflow-y: hidden;
    overflow: hidden;
    overscroll-behavior: none;
}

body {

    background-repeat: no-repeat;
    background-size: cover;

    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    padding: 0 !important;
    margin: 0 !important;
    height: 100%;
    touch-action: pan-x pan-y;
    overflow-y: hidden;

}

.bold {
    font-weight: 700;
}

.light {
    color: var(--grey-75);
}

.center {
    text-align: center;
}

.vs-button--dark {
    background-color: rgba(0, 0, 0, 0.1) !important;
    color: #000 !important;
}

.vs-button--dark:hover {
    box-shadow: 0px 10px 20px -10px rgba(var(--vs-color), 0.2) !important;
}

.vs-button--transparent {
    color: #000 !important;
}

.vs-button__content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 3px;
    font-family: 'montserrat' !important;
    font-weight: 500 !important;
}

.vs-input-content input {
    height: 48px !important;
}

.vs-button--size-large .vs-button__content {
    padding: 13px 15px !important;
}

form {
    width: 100%;
    gap: 10px;
    display: flex;
    flex-direction: column;
}

.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.25s ease-out;
}

.slide-up-enter-from {
    opacity: 0;
    transform: translateY(30px);
}

.slide-up-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}

.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.25s ease-out;
}

.slide-down-enter-from {
    opacity: 0;
    transform: translateY(-30px);
}

.slide-down-leave-to {
    opacity: 0;
    transform: translateY(30px);
}

a {
    color: var(--primary);
}

.slideout-panel {
    z-index: 2300 !important; /* ensure all slideout panels (incl. AI) sit above search bar/suggestions */
    position: absolute;
    right: 0;

}

.slideout {
    pointer-events: auto;
    width: 25% !important;
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 0;
    overflow-x: hidden;

}

/* Glassy slide-up panel (bottom) */
.slideout.open-on-bottom {
    background: rgba(255, 255, 255, 0.78)!important;
    -webkit-backdrop-filter: saturate(150%) blur(16px)!important;
    backdrop-filter: saturate(150%) blur(16px)!important;
    border: 1px solid rgba(255, 255, 255, 0.35)!important;
    border-top-left-radius: 18px!important;
    border-top-right-radius: 18px!important;
    box-shadow: 0 -12px 30px rgba(16, 24, 40, 0.20)!important;
    transition: backdrop-filter .25s ease, background-color .25s ease, box-shadow .25s ease, border-color .25s ease!important;

}



/* Grabber - clickable area */
.slideout.open-on-bottom::after {
    content: '';
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 30px;
    background: transparent!important;
    z-index: 10000!important;
}

/* Grabber - visual indicator */
.slideout.open-on-bottom::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 44px;
    height: 5px;
    border-radius: 999px;
    background: rgba(0,0,0,0.20);
    z-index: 10001;
}

/* Make inner content float on glass without extra backgrounds */
.slideout.open-on-bottom *:not(button):not(.vs-button):not(img):not(.grabber) {
    background-color: transparent;
}

.blog-container .slideout {
    width: 60% !important;
}

.vs-sidebar__item img {
    width: 32px;
    height: auto;
}

.vs-sidebar__item .active {
    display: none;
}

.vs-sidebar__item.active .active {
    display: block;
}

.vs-sidebar__item.active .inactive {
    display: none !important;
}

.slideout-panel-bg {
    z-index: 100 !important;
}
.tourial-app.poi-panel-open .slideout-panel-bg {
    opacity: 0 !important;
}

.vs-select__label {
    font-size: 14px;
    color: var(--natural-grey-2);
    margin-bottom: 10px;
}

h1 {
    font-size: 2.5rem;
}

textarea {
    font-family: 'montserrat' !important;
}

/*
input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
    font-size: 1rem;
    font-family: 'montserrat' !important;

}
*/

.tourial-app {
    height: 100%;
}

.vs-dialog-content.blur {
    -webkit-backdrop-filter: saturate(130%) blur(15px) !important;
    backdrop-filter: saturate(130%) blur(15px) !important;

}

.vs-sidebar__item__text-tooltip {
    background: #FFFFFF;
    /* Dropshadow 2 */

    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.27) !important;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding-right: 10px;
    padding-left: 10px;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    left: 50px !important;

}

@page {
    size: 7in 9.25in;
    margin: 0mm;
}

.vs-tooltip {
    padding: 0 !important;
}

.vs-tooltip.left {
    margin-right: -10px !important;
}

/* custom scrollbar */
::-webkit-scrollbar {
    width: 15px;
}

::-webkit-scrollbar-track {
    background-color: white;
}

::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 3px solid transparent;
    background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
    background-color: transparent;
}

.fade-enter-active,
.fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
}

.fade-enter-active {
    transition-delay: .25s;
}

.fade-enter,
.fade-leave-active {
    opacity: 0
}

@font-face {
    font-family: "lg";
    src: url(./assets/fonts/lg.ttf) format("truetype");
}

.vs-select__options {
    z-index: 2300 !important;
}

.vs-sidebar__item .vs-avatar-content:hover .vs-avatar {
    box-shadow: none !important;
}

.vs-sidebar__item .vs-avatar-content:hover img {
    transform: unset !important;
}

.vs-sidebar__item .vs-avatar {
    box-shadow: none !important;
    background: unset !important;
}

.vs__dropdown-toggle {
    background: unset !important;
    border: unset !important;
}

.vs__dropdown-menu {
    padding: 0 !important;
}

.vs--single .vs__selected {
    font-size: 1rem !important;
    margin-left: 4px !important;
    font-family: 'Montserrat';
}

input.vs__search {
    margin-left: 4px !important;
    font-size: 1rem !important;

}

.vs-select__input.simple {
    font-size: 1rem !important;
    padding-left: 10px !important;
}

/* MOBILE */
@media (max-width: 600px) {
    .slideout {
        width: 100% !important;
        height: auto!important;
        max-height: 70%!important;
        padding-bottom: 32px;
        padding-left: 0;
        padding-right: 0;
        overflow: hidden;
        z-index: 2100 !important;
    }

    /* Mobile tuning for glass panel */
    .slideout.open-on-bottom {
        background: rgba(255, 255, 255, 0.6);
        -webkit-backdrop-filter: saturate(150%) blur(16px);
        backdrop-filter: saturate(200%) blur(4px);
        border-top-left-radius: 18px;
        border-top-right-radius: 18px;
        box-shadow: 0 -14px 36px rgba(16, 24, 40, 0.22);
    }

    .slideout-panel-bg {
        z-index: 2000 !important;
    }

    input:not(.vs__search),
    .vs-select__chips__chip {
        height: 50px !important;
        font-size: 18px !important;
    }

    .slideout-panel-bg {
        opacity:0!important;
    }
}

.vs-checkbox-mask:before {
    border: 2px solid #b1b1b1 !important;
}

.tourial-expiring-notification h4 {
    font-weight: 100 !important;
}

.tourial-expiring-notification {
    z-index: 10000!important;
}

.tourial-expiring-notification .vs-notification {
    max-height: unset!important;
}

.tourial-app.tourial-native {
    padding-top: 50px!important;
    box-sizing: border-box!important;
}

body.app .vs-notification:last-of-type {
    max-height: 130px!important;
    /* notch */
    padding-top: max(10px, env(safe-area-inset-top)) !important;
    box-sizing: border-box!important;
}

body.app .lg-toolbar.lg-group {
    top: env(safe-area-inset-top)!important;
}

body.app .vs-notification:last-of-type .vs-notification__close {
    top: calc(5px + env(safe-area-inset-top))!important;
}

.vs-button.animate {
    /* animate background white gradient */
    background: linear-gradient(60deg, rgba(var(--vs-primary), 0.6), rgba(var(--vs-primary), 1), rgba(var(--vs-primary), 0.7));
    background-size: 200% 100%;
    animation: animate 4s ease infinite alternate;
}

@keyframes animate {
    0% {
        background-position: 200% 0;
        box-shadow: 0px 10px 35px 0px rgba(204, 136, 68, 0.4);
    }
    100% {
        background-position: -200% 0;
        box-shadow: 50px 10px 35px 0px rgba(204, 145, 68, 0.6);
    }
}

.slideout.open-on-bottom:not(:has(.poi-container))::after {
    display: none!important;
}

.tourial-app.poi-panel-open .slideout-panel-bg {
    display: none!important;
    pointer-events: none!important; /* ensure overlay never blocks clicks when POI panel is open */
}

/* Hide cookie banner and floating settings handle whenever POI panel is open */
.tourial-app.poi-panel-open .wised-cookie-consent,
.tourial-app.poi-panel-open .wised-cookie-consent__settings {
    display: none !important;
    pointer-events: none !important;
}

.mx-datepicker-main {
    z-index: 10000!important;
}

.slideout:has(.addtotripdialog-container),
.slideout:has(.newtripdialog-container),
.slideout:has(.tripdatedialog-container),
.slideout:has(.deactivateddialog-container),
.slideout:has(.trialdialog-container),
.slideout:has(.renewfaileddialog-container),
.slideout:has(.offlinedialog-container),
.slideout:has(.updateappdialog-container),
.slideout:has(.cancelsubscription-container),
.slideout:has(.editstaydialog-container),
.slideout:has(.newstaydialog-container),
.slideout:has(.edittripdialog-container),
.slideout:has(.pending-checkout) {
    z-index: 11000 !important;
}

/* Bumping the inner .slideout z-index above is not enough: .slideout-panel
   (the vue2-slideout-panel wrapper) establishes its own stacking context via
   position:absolute + z-index (see rule above, z-index: 2300), which is LOWER
   than .mobilenavbar-container's z-index: 3000 (MobileNavbar.vue). Since they
   are siblings, no z-index on a descendant of .slideout-panel can render above
   the navbar until the wrapper itself clears 3000. Raise the wrapper for these
   "true dialog" panels (and the AI assistant) so they render above the bottom
   navbar on mobile instead of behind it. */
.slideout-panel:has(.ai-assistant-panel),
.slideout-panel:has(.addtotripdialog-container),
.slideout-panel:has(.newtripdialog-container),
.slideout-panel:has(.tripdatedialog-container),
.slideout-panel:has(.deactivateddialog-container),
.slideout-panel:has(.trialdialog-container),
.slideout-panel:has(.renewfaileddialog-container),
.slideout-panel:has(.offlinedialog-container),
.slideout-panel:has(.updateappdialog-container),
.slideout-panel:has(.cancelsubscription-container),
.slideout-panel:has(.editstaydialog-container),
.slideout-panel:has(.newstaydialog-container),
.slideout-panel:has(.edittripdialog-container),
.slideout-panel:has(.pending-checkout) {
    z-index: 3100 !important;
}


.poi-mobile-pane .poi-container {
    padding-bottom: 32px!important;
}

.mx-datepicker-popup {
    z-index: 100000!important;
}
</style>
